export const PERIOD_PICKER_TYPE_YEAR = 'year'
export const PERIOD_PICKER_TYPE_HALF = 'half'
export const PERIOD_PICKER_TYPE_QUARTER = 'quarter'
export const PERIOD_PICKER_TYPE_MONTH = 'month'
export const PERIOD_PICKER_TYPE_WEEK = 'week'
export const PERIOD_PICKER_TYPE_DAY = 'day'
export const PERIOD_PICKER_TYPE_PERIOD = 'period'